import React from "react";
import { StrSplit, NoMaxWidthTooltip } from "../../utils/utils.js";
import { ReactComponent as QuestionMark } from "../../assets/navbar/QuestionMark.svg";

const LossComponent = (props) => {
  return (
    <div className="flex flex-row items-center mt-[-10px] mb-[10px]">
      <div className=" flex items-center justify-start font-Poppins-Light text-sm mr-[10px]">{"Perte et rapport cru/ cuit : *" + props.total_loss.toFixed(2) + "kg"}</div>
      <NoMaxWidthTooltip
        title={
          <div className="shadow w-[600px] bg-white p-[20px] m-[-10px] rounded-xl">
            <div className="flex flex-row border-[#F3F5F7] border-b-[1px] justify-between">
              <div className="p-[5px] pt-[-5px]">
                {StrSplit("Perte à la\nvente au détail").map((current) => {
                  return (
                    <p className="font-Poppins-SemiBold text-sm text-black" key={current}>
                      {current}
                    </p>
                  );
                })}
                <p className="font-Poppins-SemiBold text-base text-[#245FFF]">{props.loss.sales_loss ? props.loss.sales_loss : 0}%</p>
              </div>

              <div className="p-[5px]">
                {StrSplit("Perte non comestibles\nchez le consommateur").map((current) => {
                  return (
                    <p className="font-Poppins-SemiBold text-sm text-black" key={current}>
                      {current}
                    </p>
                  );
                })}
                <p className="font-Poppins-SemiBold text-base text-[#FFC62B]">{props.loss.com_loss ? props.loss.com_loss : 0}%</p>
              </div>

              <div className="p-[5px]">
                {StrSplit("Rapport cru/ cuit chez\nle consommateur").map((current) => {
                  return (
                    <p className="font-Poppins-SemiBold text-sm text-black" key={current}>
                      {current}
                    </p>
                  );
                })}
                <p className="font-Poppins-SemiBold text-base text-[#FF3E3E]">{props.raw_to_cooked === 1 ? 100 : props.raw_to_cooked === 0 ? 100 : (props.raw_to_cooked * 100).toFixed(2)}%</p>
              </div>
            </div>

            <div className="flex flex-row mt-[10px]">
              <p className="font-Poppins-Regular text-black p-[5px] text-sm">Formule de calcul</p>
              <div className="font-Poppins-Light text-black p-[5px] bg-[#F8FAFB] rounded-sm text-sm flex flex-row">
                <p className="font-Poppins-Light ">{"1kg / (1 - "}</p>
                <p className="font-Poppins-SemiBold text-[#245FFF]">{props.loss.sales_loss ? props.loss.sales_loss : 0}%</p>
                <p className="font-Poppins-Light ">{") / (1 - "}</p>
                <p className="font-Poppins-SemiBold text-[#FFC62B]">{props.loss.com_loss ? props.loss.com_loss : 0}%</p>
                <p className="font-Poppins-Light ">{") / "}</p>
                <p className="font-Poppins-SemiBold text-[#FF3E3E]">{props.raw_to_cooked === 1 ? 100 : props.raw_to_cooked === 0 ? 100 : (props.raw_to_cooked * 100).toFixed(2)}%</p>
                <p className="font-Poppins-Light ">{" = "}</p>
                <p className="font-Poppins-Light">{props.total_loss.toFixed(2)}</p>
                <p className="font-Poppins-Light">kg</p>
              </div>
            </div>
          </div>
        }
      >
        <QuestionMark width="15" height="15" stroke="black" />
      </NoMaxWidthTooltip>
    </div>
  );
};

export default LossComponent;
